const DATA_URL_PREFIX = /^data:image\/([a-zA-Z0-9+.-]+);base64,/i;

const SIGNATURE_TO_MIME: Array<{ signature: string; mime: string }> = [
  { signature: '/9j/', mime: 'image/jpeg' },
  { signature: 'UklGR', mime: 'image/webp' },
  { signature: 'R0lGOD', mime: 'image/gif' },
  { signature: 'AAAAIGZ0eXBhdmlm', mime: 'image/avif' },
  { signature: 'AAAAHGZ0eXBhdmlm', mime: 'image/avif' },
];

export function normalizeImageDataUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return '';
  const match = url.match(DATA_URL_PREFIX);
  if (!match) return url;

  const currentMime = `image/${(match[1] || '').toLowerCase()}`;
  const payload = url.slice(match[0].length);
  if (!payload) return url;

  for (const { signature, mime } of SIGNATURE_TO_MIME) {
    if (payload.startsWith(signature) && mime !== currentMime) {
      return `data:${mime};base64,${payload}`;
    }
  }

  return url;
}
